import { render, staticRenderFns } from "./PermissionsSelect.vue?vue&type=template&id=094d4f12&scoped=true&"
import script from "./PermissionsSelect.vue?vue&type=script&lang=js&"
export * from "./PermissionsSelect.vue?vue&type=script&lang=js&"
import style0 from "./PermissionsSelect.vue?vue&type=style&index=0&id=094d4f12&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "094d4f12",
  null
  
)

export default component.exports